// Small helpers shared by the administration pages.
import React from 'react';
import type { AttrType } from '../../types';

export const TYPE_LABEL: Record<AttrType, string> = {
  TEXT: 'Text', TEXTAREA: 'Text lung', NUMBER: 'Număr', DATE: 'Dată', DATETIME: 'Dată și oră', BOOLEAN: 'Da/Nu',
  LIST: 'Listă', ASSIGNEE: 'Repartizare', DEPARTMENT: 'Compartiment', USER: 'Utilizator', LOCATION: 'Locație pe hartă',
};
export const typeLabel = (t: string) => (TYPE_LABEL as Record<string, string>)[t] || t;

/** ASCII slug used for codes: "Număr contract" → "numar_contract". */
export function slug(s: string): string {
  return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

export const TYPE_ICONS = ['file', 'book', 'mail', 'receipt', 'contract', 'folder', 'shield', 'briefcase', 'clipboard', 'users'];
export const PRESET_COLORS = ['#2d5fb8', '#0b7aa8', '#1a7f4b', '#b45309', '#c2410c', '#7c3aed', '#be185d', '#475569'];

export function PageHead({ title, text, children }: { title: string; text?: string; children?: React.ReactNode }) {
  return (
    <div className="toolbar" style={{ marginBottom: 16 }}>
      <div><h1 style={{ fontSize: 19 }}>{title}</h1>{text && <p className="muted small">{text}</p>}</div>
      <span className="grow" />
      {children}
    </div>
  );
}

export function Loading() { return <p className="muted" style={{ padding: 24 }}>Se încarcă…</p>; }
